import { PageHero } from "./PageHero";
import { Seo } from "./Seo";

export const LegalPage = ({ seo, label, title, updated, intro, sections, testId }) => (
  <main data-testid={testId}>
    <Seo {...seo} />
    <PageHero label={label} title={title} text={intro} />
    <section className="bg-white py-20 lg:py-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <p className="text-xs uppercase tracking-[0.25em] text-[#6B7280]" style={{ fontFamily: "var(--font-heading)" }}>
          Last updated: {updated}
        </p>
        <div className="mt-10 space-y-12">
          {sections.map((s, i) => (
            <div key={s.heading} data-testid={`legal-section-${i}`}>
              <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight text-[#041525]" style={{ fontFamily: "var(--font-heading)" }}>
                {i + 1}. {s.heading}
              </h2>
              <div className="mt-4 space-y-4">
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="text-[15px] text-[#4B5563] leading-[1.85]">{p}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 rounded-2xl border border-[#006FD6]/20 bg-[#F6F8FA] p-8">
          <p className="text-sm text-[#6B7280] leading-relaxed">
            This document is a structural draft prepared for professional legal review. Provisions
            marked as placeholders must be completed and approved by qualified legal counsel before
            launch. Nothing on this page constitutes legal, financial, or investment advice.
          </p>
        </div>
      </div>
    </section>
  </main>
);
